import { useEffect } from "react";

import InputComment from "../InputComment";
import Helpers from "../../commons/helpers";
import CommentListView from "../CommentListView";

import { useComment } from "../../hooks/comment";
import { IDataComment } from "../../commons/interfaces";
import { DiscussionGroupType } from "../../constants/enums";
import { AlertProvider } from "../../providers/AlertProvider";
import { useCommentContext } from "../../providers/CommentProvider";

import "../../styles/comment.css";
import "../../styles/inputComment.css";
import "../../styles/commentListView.css";
import "../../styles/commentContainer.css";


export enum ModeCallBackComment {
    Create,
    Update,
    Delete,
}

interface IProps {
    isDetail: boolean;
    requestLevel: number;
    isReadMore?: boolean;
    dataComments: IDataComment[];

    threadId: string;
    channelId: string;

    onCallBack?: (data: { firstComment?: IDataComment, mode: ModeCallBackComment }) => void;
}

const CommentInPost = ({
    isDetail,
    threadId,
    channelId,
    isReadMore,
    requestLevel,
    dataComments,
    onCallBack,
    ...rest
}: IProps) => {

    const { userLogin, reactionIcons } = useCommentContext();

    const {
        pageData,
        setPageData,
        listComments,
        setListComments,
        getListComment,

        handleReaction,
        handleUnReaction,

        handleHideComment,
        onViewReplyComment,

        deleteComment,
        createComment,
        updateComment,
    } = useComment({
        threadId,
        requestLevel,
        discussionGroupType: DiscussionGroupType.ThreadPost,
    });

    useEffect(() => {
        (async () => {
            if (isDetail) {
                getListComment();
            } else {
                setListComments([]);
                setPageData({
                    currentPage: 1,
                    totalCount: 0,
                    totalPages: 0,
                });
            }
        })();
    }, [isDetail]);

    return (
        <AlertProvider>
            <div {...rest} className="cr-container cr-common">
                <CommentListView
                    requestLevel={requestLevel}
                    reactionIcons={reactionIcons || []}
                    dataComment={isDetail ? listComments : dataComments}

                    isDisableDelete={!isDetail}
                    isDisableUpdate={!isDetail}
                    isDisableReport={!isDetail}
                    hiddenActionComment={!isDetail}

                    isReadMore={isDetail
                        ? isReadMore
                        : (pageData.currentPage < pageData.totalPages)
                    }
                    readMoreComment={isDetail
                        ? () => { getListComment(true) }
                        : undefined
                    }

                    reaction={handleReaction}
                    unReaction={handleUnReaction}

                    onHideReplyComment={handleHideComment}
                    onViewReplyComment={onViewReplyComment}

                    deleteMessage={async (messageId: string) => {
                        const newData = await deleteComment(messageId);

                        Helpers.isFunction(onCallBack) &&
                            onCallBack({ firstComment: newData[0], mode: ModeCallBackComment.Delete });
                    }}
                    sendMessage={async (discussionValue: string, replyTo?: string) => {
                        const newData = await createComment({
                            channelId: channelId,
                            message: discussionValue,
                            replyTo: replyTo,
                        });

                        Helpers.isFunction(onCallBack) &&
                            onCallBack({ firstComment: newData[0], mode: ModeCallBackComment.Create });
                    }}
                    updateMessage={async (messageId: string, message: string) => {
                        const newData = await updateComment({
                            message: message,
                            messageId: messageId,
                        });

                        Helpers.isFunction(onCallBack) &&
                            onCallBack({ firstComment: newData[0], mode: ModeCallBackComment.Update });
                    }}
                />

                <InputComment
                    visible={false}
                    isComment={true}
                    onCancelComment={() => { }}
                    dataReplyComment={{ userComment: userLogin }}
                    sendMessage={async (discussionValue: string, replyTo?: string) => {
                        const newData = await createComment({
                            replyTo: replyTo,
                            channelId: channelId,
                            message: discussionValue,
                        });

                        Helpers.isFunction(onCallBack) &&
                            onCallBack({ firstComment: newData[0], mode: ModeCallBackComment.Create });
                    }}
                />
            </div>
        </AlertProvider>
    );
};

export default CommentInPost;
